import * as React from 'react'
import { INews } from 'src/type/news'
import { Card, WithStyles, CardMedia, CardContent, Typography, Icon, Theme, createStyles, withStyles, Chip } from '@material-ui/core'
import ReactHtmlParser from 'react-html-parser'
import { formatDate } from 'src/core/i18n/date'
import { compose } from 'redux'
import { convertUrlName, replaceDetteWithTaux } from 'src/shared/utils/helpers'
import Link from 'src/shared/Link/Link'
import { RootState } from 'src/core/redux/reducer'
import {connect} from 'react-redux'
import NewsShare from 'src/shared/News/NewsShare'
import { config } from 'src/conf/config'
import { get } from 'lodash'

const styles = (t: Theme) => createStyles({
    card: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      // maxWidth: 400,
      height: '100%',
      cursor: 'pointer'
    },
    media: {
      height: 0,
      paddingTop: '56.25%',
    },
    content: {
        position: 'relative',
        maxHeight: '150px',
        overflow: 'hidden',
        '&:after': {
            background: 'linear-gradient(top, rgba(255,255,255,0), #fff 100%)',
            content: '""',
            position: 'absolute',
            height: '80px',
            bottom: 0,
            right: 0,
            left: 0,
        }
    },
    avatar: {
      backgroundColor: '#ED1C24',
    },
    newsTitle: {
        lineHeight: 'inherit',
        marginBottom: t.spacing.unit
    },
    chip: {
        margin: '4px',
        fontSize: '0.75rem',
        height: '26px'
    },
    newsCategories: {
        marginBottom: t.spacing.unit
    },
    featured: {
        position: 'absolute',
        top: t.spacing.unit,
        right: t.spacing.unit,
        color: '#fff'
    }
  });

  
interface IProps extends WithStyles<typeof styles>,
ReturnType<typeof state2props>,
ReturnType<typeof dispatch2props>{
    entity: INews;
    pathNews: string;
    withChip?: boolean;
}

/*
   Avoid validateDOMNesting(...)
*/
const NewsContent = (message: any) => (ReactHtmlParser(message))

class NewsCard extends React.Component<IProps, {}> {
    render() {
        const {classes, entity, pathNews, enterprise, withChip, mapName} = this.props
        const chips = get(entity, "category_actu")
        return (
            <>
            <Link to={`${pathNews}/${entity.id}/${convertUrlName(entity.title)}`}>
                <Card key={`news-card-${entity.id}`} className={classes.card}>
                    <CardMedia
                        className={classes.media}
                        image={entity.img_url ? entity.img_url : config.IMG_BASE_PATH + "/news-default.jpg"}
                        title={entity.title}
                        key={`news-card-media-${entity.id}`} 
                    />
        
                    <CardContent key={`news-card-content-${entity.id}`} >
                        <Typography variant="h6" gutterBottom className={classes.newsTitle} key={`news-card-title-${entity.id}`} >
                            {(mapName && withChip && chips && chips.length > 0) && 
                                chips.split(",").filter(c => c !== "economique").map(c => (
                                    <Chip key={c} label={replaceDetteWithTaux(mapName.get(c))} className={classes.chip} />
                                ))
                            }
                            {entity.title}
                        </Typography>

                        <Typography variant="caption" gutterBottom className={classes.newsTitle} key={`news-card-author-${entity.id}`} >
                            {formatDate(entity.publish_at)}
                        </Typography>
                        <br/>
                        <div key={`news-card-message-${entity.id}`}  className={classes.content}>{NewsContent(entity.message)}</div>
                        <br/>
                    </CardContent>

                    {!enterprise && 
                        <NewsShare post={entity}/>
                    }
                    {entity.is_highlighted === true &&
                        <Icon className={classes.featured} fontSize="large" >grade</Icon>
                    }
            </Card>
          </Link>
          </>
        )
    } 
}

const dispatch2props = (dispatch: any, ownProps: any) => ({
})
const state2props = (state: RootState) => ({
    mapName: state.utils.mapCategories,
    enterprise: state.accountInfo.enterpriseSelected,
})

export default compose(    
    connect(state2props, dispatch2props),
    withStyles(styles)
)(NewsCard)


// WEBPACK FOOTER //
// ./src/shared/News/NewsCard.tsx